import { FirebaseError } from "firebase/app"

import { useAuth } from "../hooks/useAuth"

interface Props {
  children: React.ReactNode
}

const SignOutButton = () => {
  const { signOut } = useAuth()
  return <button onClick={signOut}>Sign Out</button>
}

const SignInButtons = () => {
  const { signInWithGoogle, signInWithMicrosoft } = useAuth()
  return (
    <>
      <button
        onClick={signInWithGoogle}
        className="flex w-64 items-center justify-center"
      >
        <svg viewBox="0 0 1024 1024" className="mr-2 w-6 fill-current">
          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z" />
        </svg>
        Sign in with Google
      </button>
      <button
        onClick={signInWithMicrosoft}
        className="flex w-64 items-center justify-center"
      >
        <svg
          viewBox="0 0 21 21"
          className="mr-2 w-6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="1" y="1" width="9" height="9" fill="#f25022" />
          <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
          <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
          <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
        </svg>
        Sign in with Microsoft
      </button>
    </>
  )
}

const SignInPage = ({ message }: { message?: string }) => (
  <div className="flex flex-col items-center justify-center">
    {message ? <p>{message}</p> : <h1>Sign In Page</h1>}
    <SignInButtons />
  </div>
)

// TODO(arie): Make different pages instead
export const AuthGuard: React.FC<Props> = ({ children }) => {
  const { user, loading, error, claims } = useAuth()

  if (loading) return <div>Loading...</div>

  if (error) {
    const isPopupTimeout =
      error instanceof FirebaseError &&
      (error.code === "auth/popup-closed-by-user" ||
        error.code === "auth/popup-blocked")
    if (isPopupTimeout) {
      return <SignInPage message="Sign-in timed out — please try again." />
    }
    return (
      <div>
        Error: {JSON.stringify(error)}
        <br />
        <SignOutButton />
      </div>
    )
  }

  if (!user || !claims) return <SignInPage />

  if (!claims.isApproved) {
    return (
      <div>
        <div>😅 You are on the waitlist...</div>
        <br />
        <SignOutButton />
      </div>
    )
  }

  return (
    <div>
      {children}
      <br />
      <SignOutButton />
    </div>
  )
}

export default AuthGuard
